export const GET_TWO_FA_URL = '/api/v1/user/two-factor-authentication'
export const DISABLE_TWO_FA_URL = '/api/v1/user/two-factor-authentication'
export const USER_VERIFICATION_RESENT = 'api/v1/user/verification/resent'
export const CHECK_USER_VERIFICATION = '/api/v1/user/verification/check'
